// extracted by mini-css-extract-plugin
export default {"container":"IssueForm_container__M3hvp","options":"IssueForm_options__GTtgj","buttons":"IssueForm_buttons__Azpv5"};